
export default {
  name: "OnProgress",
  props: {
    message: String
  },

}
